
<script>
  import { HorizontalBar } from 'vue-chartjs'

  export default {
    extends: HorizontalBar,
    props: {
      chartdata: {
        type: Object,
        default: null
      },
    },
    data: () => ({
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              fontColor: "black",
              fontSize: 16,
              fontStyle: "500"
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              fontColor: "black",
              fontSize: 14,
              fontStyle: "bold",

            }
          }]
        }
      }
    }),
    mounted () {
      this.renderChart(this.chartdata, this.options)
      this.$refs.canvas.style.height = (100 + this.chartdata.labels.length * 40) + "px";
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/bar-chart.vue